/* eslint-disable no-param-reassign */

import { localStorageStrategy } from '../data/strategies';

export function makeTutorial () {
    return {
        namespaced: true,
        state: {
            tutorial: null,
            enabled: false,
        },
        getters: {
            tutorialKey (state, getters, rootState) {
                return `${rootState.solution.id}:tutorial_completed`;
            },
            tutorialCompleted (state) {
                return !!state.tutorial;
            },
            tutorialCompletionDate (state) {
                return state.tutorial ? new Date(state.tutorial).toLocaleString() : null;
            },
        },
        mutations: {
            SET_TUTORIAL (state, tutorial) {
                state.tutorial = tutorial;
            },
        },
        actions: {
            completeTutorial ({ getters, commit }) {
                const date = Date.now();
                localStorage.setItem(getters.tutorialKey, JSON.stringify(date));
                commit('SET_TUTORIAL', date);
                console.log('[Tutorial] Tutorial completed');
            },
            updateTutorial ({ commit, getters }) {
                commit('SET_TUTORIAL', JSON.parse(localStorageStrategy(getters.tutorialKey)));
                console.log('[Tutorial] Stored tutorial completion:', getters.tutorialCompletionDate);
            },
        },
    };
}
